<template>
  <div>
    <v-row
      v-for="text in user.quick_texts_www"
      :key="text.id"
    >
        <v-col 
          sm=3
        >
          <v-text-field
            label="nazwa"
            v-model="text.name"
            dense
          ></v-text-field>
        </v-col>
        <v-col 
          sm=8
        >
          <v-text-field
            label="szablon"
            v-model="text.template"
            dense
          ></v-text-field>
        </v-col>
        <v-col 
          sm=1
        >
          <v-btn color="error" @click="remove(text)" small
                ><v-icon>delete</v-icon></v-btn>
  
        </v-col>
    </v-row> 

      <v-btn color="success" @click="add()" small
                ><v-icon>add</v-icon></v-btn
              >
  </div>          
</template>

<script>

export default {
  name: "UserEditQuickTextWww",
  props: ["user"],
  components: {
    
  },
  data: () => ({

  }),
  computed: {

  },
  methods: {
    add: function() {
      if(this.user.quick_texts_www === null){
        this.user.quick_texts_www = [];
      }
      this.user.quick_texts_www.push(
        {
          id: Date.now(), name: '', template: ''
        }
      );
    },
    remove: function(textButton){
      this.user.quick_texts_www =
         this.user.quick_texts_www.filter((current) => {
          return current.id !== textButton.id;
        });
    }
  },
  mounted() {
   
  },
};
</script>


<style>
</style>